import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Section from './Section'
import SectionTitle from './SectionTitle'
import DemoSurvey from './DemoSurvey'

const STEPS = [
  { key: 'intake', tone: 'bg-primary' },
  { key: 'mid', tone: 'bg-primary' },
  { key: 'exit', tone: 'bg-primary' },
  { key: 'followup', tone: 'bg-secondary-dark' },
]

const ParcoursSection: React.FC = () => {
  const intl = useIntl()

  return (
    <Section id="parcours" bg="bg-background">
      <SectionTitle
        title={intl.formatMessage({ id: 'marketing.parcours.title' })}
        subtitle={intl.formatMessage({ id: 'marketing.parcours.subtitle' })}
      />

      <ol className="grid gap-6 md:grid-cols-4 md:gap-4">
        {STEPS.map((step, i) => (
          <li key={step.key} className="relative pl-8 md:pl-0">
            {/* Phone: a vertical rail between the points. The last point has
                nothing to connect to, so it gets no rail. */}
            {i < STEPS.length - 1 && (
              <div className="md:hidden absolute left-[10px] top-3 bottom-[-1.5rem] w-0.5 bg-border-light" aria-hidden="true" />
            )}
            {/* Desktop: the dot and the line share one flex row, so the line
                is centred on the dot by layout, whatever the spacing scale.
                The line overshoots into the grid gap to reach the next dot. */}
            <div className="md:flex md:items-center md:mb-4">
              <span className={`absolute left-0 top-1.5 md:static md:shrink-0 block h-3 w-3 rounded-full ring-4 ring-background ${step.tone}`} />
              <div className="hidden md:block h-0.5 flex-1 bg-border-light md:-mr-4" aria-hidden="true" />
            </div>
            <p className="text-xs font-bold uppercase tracking-wider text-primary">
              <FormattedMessage id={`marketing.parcours.step.${step.key}.when`} />
            </p>
            <h3 className="text-lg font-bold text-foreground mt-1">
              <FormattedMessage id={`marketing.parcours.step.${step.key}.label`} />
            </h3>
            <p className="text-sm text-foreground-muted mt-1">
              <FormattedMessage id={`marketing.parcours.step.${step.key}.text`} />
            </p>
          </li>
        ))}
      </ol>

      <p className="mt-10 text-base text-foreground max-w-3xl">
        <FormattedMessage id="marketing.parcours.footnote" />
      </p>

      <div className="mt-10">
        <DemoSurvey />
      </div>
    </Section>
  )
}

export default ParcoursSection
